import React from 'react';
import styled from 'styled-components/macro';
import BaseInput, { type InputProps as BaseInputProps } from '../../../ui/Input';
import { getFieldWrapStyle } from '../Field';

export type InputProps = {
  fontSize?: number
} & BaseInputProps

const StyledInput = styled(BaseInput)<{ $hasError?: boolean }>`
  & > div {
    padding: 0;
  }

  border: 1px solid ${({ $hasError }) => ($hasError ? 'var(--red-100)' : 'transparent')};

  &:focus-within,
  &:active {
    border-color: ${({ $hasError }) => ($hasError ? 'var(--red-100)' : 'var(--black-10)')};
  }
`;

const Input = ({ style, error, fontSize = 18, ...props }: InputProps) => {
  const { border: _border, ...wrapStyle } = getFieldWrapStyle(error, { fontSize, ...style });

  return <StyledInput {...props} error={error} $hasError={!!error} style={wrapStyle} />;
};

export default Input;
